import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";

import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import { FILTER_USER_ROLES } from "common/constants";
import { roleBasedRolesList } from "common/helpers";
import GridItem from "components/Grid/GridItem.js";
import { fetchGetRequest } from "common/service";
import { API_BASE_URL } from "common/constants";

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "5px",
    padding: "16px",
    marginBottom: "16px",
  },
  filterLabel: {
    marginBottom: "16px",
    color: "#333333",
    fontWeight: 600,
  },
  textField: {
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
  },
  applyButton: {
    marginTop: "8px",
    borderRadius: "4px",
  },
}));

const CompanyFacilityFilter = ({ onApply, hideCompanyFilter = false, showRolesFilter = false, setCompanyList = () => {} }) => {
    const userDetails = JSON.parse(localStorage.getItem("user-details"));
    const loggedUserRole = userDetails !== null ? userDetails.roles[0].role : "";
    let rolesDropdown = roleBasedRolesList(FILTER_USER_ROLES);

    const [facilityList, setFacilityList] = useState([]);
    const [companyList, setCompaniesList] = useState([]);
    const [userRole, setUserRole] = useState("all");
    const [facility, setFacility] = useState("");
    const [company, setCompany] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");

    const classes = useStyles();

    useEffect(() => {
      if(!hideCompanyFilter) {
        getCompanyList();
        getAllFacilitiesList();
      }
    }, []);

    const getCompanyList = async() => {
      const endPoint = `${API_BASE_URL}/user/supplier`;
      const list = await fetchGetRequest("GET", endPoint);
      setCompaniesList(list?.content || []);
      if(setCompanyList) {
        setCompanyList(list?.content || []);
      }
    }

    const getAllFacilitiesList = async() => {
      const endPoint = `${API_BASE_URL}/user/practice?pageNumber=0&sortBy=name&sortOrder=ASC`;
      if(company) {
        endPoint += `&supplierId=${company}`;
      }
      const facilityListData = await fetchGetRequest("GET", endPoint);
      setFacilityList(facilityListData?.content || []);
    }

    const handleApply = () => {
      const filterData = {
        name: name || undefined,
        email: email || undefined,
        company: company || undefined,
        facility: facility || undefined,
        role: userRole || undefined,
      };
      if (onApply) {
        onApply(filterData);
      }
    };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Box className={classes.filterContainer}>
          <Box className={classes.filterLabel}>Filter By</Box>
          <GridContainer>
            <GridItem xs={12} sm={12} md={2}>
              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                margin="normal"
                variant="standard"
                className={classes.textField}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <TextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="normal"
                variant="standard"
                className={classes.textField}
              />
            </GridItem>
            {!hideCompanyFilter && ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser"].includes(loggedUserRole) && <GridItem xs={12} sm={12} md={2}>
              <TextField
                select
                fullWidth
                label="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                margin="normal"
                variant="standard"
                className={classes.textField}
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {companyList.map((companyItem) => (
                  <MenuItem key={companyItem.supplierId || companyItem.id} value={companyItem.supplierId || companyItem.id}>
                    {companyItem.name}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>}
            {!hideCompanyFilter && ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser"].includes(loggedUserRole) && <GridItem xs={12} sm={12} md={2}>
              <TextField
                select
                fullWidth
                label="Facility"
                value={facility}
                onChange={(e) => setFacility(e.target.value)}
                margin="normal"
                variant="standard"
                className={classes.textField}
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {company ? facilityList?.filter((facilityItem) => facilityItem.supplierId === company).map((facilityItem) => (
                    <MenuItem key={facilityItem.practiceId || facilityItem.id} value={facilityItem.practiceId || facilityItem.id}>
                      {facilityItem.name}
                    </MenuItem>
                  )) : facilityList?.map((facilityItem) => (
                    <MenuItem key={facilityItem.practiceId || facilityItem.id} value={facilityItem.practiceId || facilityItem.id}>
                      {facilityItem.name}
                    </MenuItem>
                  ))}
              </TextField>
            </GridItem>}
            {showRolesFilter && <GridItem xs={12} sm={12} md={2}>
              <TextField
                select
                fullWidth
                label="Select Role"
                value={userRole}
                onChange={(e) => setUserRole(e.target.value)}
                margin="normal"
                variant="standard"
                className={classes.textField}
              >
                {rolesDropdown.map((val) => (
                  <MenuItem key={val.key} value={val.key}>
                    {val.value}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>}
            <GridItem xs={12} sm={12} md={2}>
              <Box display="flex" alignItems="flex-end" height="100%" paddingTop={1}>
                <Button color="danger" onClick={handleApply} className={classes.applyButton}>APPLY</Button>
                {/* <Button color="danger" onClick={onReset} className={classes.applyButton}>RESET</Button> */}
              </Box>
            </GridItem>
          </GridContainer>
        </Box>
      </GridItem>
    </GridContainer>
  );
};

export default CompanyFacilityFilter;
